import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { trackC1 } from '../utils/trackMetric';
import * as MetricsEvents from '../constants/metrics';
import { isAutoSaveStarterServicesEligible } from '../utils/autoSaveStarterEligibility';
import AutoSaveStarterServices from './AutoSaveStarterServices';
import EmptyServiceListModal from './EmptyServiceListModal';

// Zero-state seam: fires the shared exposure + eligible-population trigger EIDs, then renders the viewer's arm.
const ZeroStateExperience = ({
  isFirstTimeEditorVisit,
  widgetId,
  staticContent,
  ctaUrl,
  locale,
  olaBenefitsZeroStateExperiment,
  isAddServicesMutatorExperiment,
  websiteCreatedDate,
  experimentReleaseDate
}) => {
  useEffect(() => {
    trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_IMPRESSION);

    // Enrollment trigger EID for the eligible population: first-time editor landers.
    if (isFirstTimeEditorVisit) {
      trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_AUTOSAVE_STARTER_ELIGIBLE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showAutoSaveStarter = isAutoSaveStarterServicesEligible({ isFirstTimeEditorVisit });

  if (showAutoSaveStarter) {
    return <AutoSaveStarterServices widgetId={ widgetId } staticContent={ staticContent } />;
  }

  return (
    <EmptyServiceListModal
      widgetId={ widgetId }
      ctaUrl={ ctaUrl }
      staticContent={ staticContent }
      locale={ locale }
      olaBenefitsZeroStateExperiment={ olaBenefitsZeroStateExperiment }
      isAddServicesMutatorExperiment={ isAddServicesMutatorExperiment }
      websiteCreatedDate={ websiteCreatedDate }
      experimentReleaseDate={ experimentReleaseDate }
    />
  );
};

ZeroStateExperience.propTypes = {
  isFirstTimeEditorVisit: PropTypes.bool,
  widgetId: PropTypes.string,
  staticContent: PropTypes.object,
  ctaUrl: PropTypes.string,
  locale: PropTypes.string,
  olaBenefitsZeroStateExperiment: PropTypes.string,
  isAddServicesMutatorExperiment: PropTypes.bool,
  websiteCreatedDate: PropTypes.string,
  experimentReleaseDate: PropTypes.string
};

export default ZeroStateExperience;
